import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { FormInputAutocompleteComponent } from './form-input-autocomplete.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import {SharedModule} from "@shared";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        PopoverModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        TooltipModule,
        MatTooltipModule,
        SharedModule
    ],
    exports: [FormInputAutocompleteComponent],
    declarations: [FormInputAutocompleteComponent]
})
export class FormInputAutocompleteModule {}
